{
  "$schema": "./schema.json",
  "agents": {
    "reasonExplanation": {
      "title": "Suggested explanation",
      "originalText": "Original text",
      "enhancedText": "Suggested version",
      "generatingEnhancedTitle": "Preparing suggestion…",
      "generatingEnhancedDescription": "Reviewing your text and preparing a new version",
      "acceptEnhanced": "Use suggested version",
      "requestFurtherEnhancement": "Create another version",
      "cancel": "Cancel",
      "button": "Save",
      "regeneratePlaceholder": "Optional: Add details or guidance for a better suggestion…",
      "regenerateButton": "Create new version with input",
      "aiAssist": "AI Assist",
      "tooltip": "Get help writing a clear and structured explanation"
    }
  }
}
